// extracted by mini-css-extract-plugin
module.exports = {"root":"SelectPayment_root__293Og","text":"SelectPayment_text__4n-eT","title":"SelectPayment_title__2d6JB","btn":"SelectPayment_btn__1cANd"};